export interface Member {
  id: string;
  name: string;
  company: string;
  title: string;
  description: string;
  about?: string;
  website?: string;
  phone?: string;
  email?: string;
  category: string;
  image?: string;
  linkedin?: string;
  facebook?: string;
  instagram?: string;
  snapchat?: string;
}

export const memberCategories = [
  "All",
  "Financial Services",
  "Construction & Contracting",
  "Marketing & Advertising",
  "Non-Profit",
  "Health & Wellness",
  "Insurance",
  "Automotive",
  "Legal Services",
  "Real Estate",
  "Retail & Food Services",
  "Technology & IT",
  "Travel & Tourism"
];

export const members: Member[] = [
  {
    id: "1",
    name: "Amber Raney",
    company: "Franklin County Foster Closet",
    title: "Executive Director",
    description: "Community Based Support to Families impacted by Foster Care and Adoption",
    about: "Executive Director and Founder",
    website: "https://franklincountyfostercloset.org",
    phone: "(417) 838-8178",
    email: "franklincofostercloset@gmail.com",
    category: "Community Services",
    image: "https://vkhjcsfgudgocgmvyigy.supabase.co/storage/v1/object/public/member-images/8d2758f6.jpg",
    linkedin: "http://linkedin.com/",
    facebook: "https://www.facebook.com/FranklinCountyFosterCloset"
  },
  {
    id: "2",
    name: "Amy Muench-Lick",
    company: "Promos Pronto",
    title: "Account Executive",
    description: "Apparel Branding | Promotional Products",
    website: "https://promospronto.com",
    phone: "(636) 390-3602",
    email: "swagstar@promospronto.com",
    category: "Marketing & Media",
    image: "https://vkhjcsfgudgocgmvyigy.supabase.co/storage/v1/object/public/member-images/477fb967.jpeg"
  },
  {
    id: "3",
    name: "Angie Holmes",
    company: "Cruise Planners",
    title: "Travel Agent",
    description: "Travel planning for cruises and land travel. I do the research and find the best experience at no cost to you!",
    about: "Hi! I'm Angie, a Cruise Planners franchise owner, and I can't wait to see where your next journey will take you. A safari? A Cruise? Alaskan train tour? How about a Historic River Cruise? Let me tell you, life is too short to not do the things, see the things, experience the things. So do them, see them and experience them! Let me help you get the most out of whatever you choose!",
    website: "http://travelmode.travel",
    phone: "(636) 544-8829",
    email: "angie.holmes@cruiseplanners.com",
    category: "Professional Services",
    image: "https://vkhjcsfgudgocgmvyigy.supabase.co/storage/v1/object/public/member-images/angie.jpg",
    facebook: "http://cptravelmode/"
  },
  {
    id: "4",
    name: "Ashley Simmons",
    company: "Simmons Strategy Solutions",
    title: "Owner",
    description: "Small Business Marketing",
    website: "http://simmonsstrategysolutions.com",
    phone: "(636) 234-4481",
    email: "ashley@simmonsstrategysolutions.com",
    category: "Marketing & Media",
    image: "https://vkhjcsfgudgocgmvyigy.supabase.co/storage/v1/object/public/member-images/e973ba6b.jpg",
    linkedin: "https://www.linkedin.com/in/ashleysimmonsbush"
  },
  {
    id: "5",
    name: "Bart Haddox",
    company: "HPS Painting and Contracting",
    title: "Owner",
    description: "Painting Contractor",
    website: "https://www.facebook.com/HPSpaintingandcontracting",
    phone: "(314) 580-2997",
    email: "bjhaddox64@gmail.com",
    category: "Construction & Trades"
  }
];
